import ForgotPassForm from "../../components/ForgotPassForm"

export default function ForgotPass() {
  return (
    <div>
      <ForgotPassForm />
    </div>
  );
}
